import { useEffect, useState } from "react";
import { siteInfo } from "@/mocks/manga";

const navLinks = [
  { href: "#hero", label: "首页" },
  { href: "#eras", label: "年代翻看" },
  { href: "#hot", label: "经典老番" },
  { href: "#rare", label: "绝版资源" },
  { href: "#archive", label: "考古专题" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200 shadow-none"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6">
        <a
          href="#hero"
          className="flex items-center gap-2.5 whitespace-nowrap"
          aria-label={`${siteInfo.name} 首页`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg text-background-50">
            073
          </span>
          <span className="font-heading text-lg md:text-xl text-foreground-950 tracking-wide">
            {siteInfo.name}
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="block rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700 whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#request"
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 lg:inline-flex"
        >
          求补旧坑
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
        >
          <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur-md lg:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#request"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            求补旧坑
          </a>
        </div>
      )}
    </header>
  );
}